export default __webpack_public_path__ + "static/icon-gas-a1e1f5da30316fffaf0c83d0e3cfc907.svg";